<template>
  <span class="k-input-container">
    <span class="k-input">
      <span class="k-input__prefix">
        <i class="k-date-input-masked__icon far fa-calendar"></i>
      </span>
      <span class="k-input__input-field-wrapper">
        <k-input
          type="text"
          class="k-date-input-masked__input-field"
          v-model="date"
          :placeholder="placeholder"
          v-maska="'##-##-####'"
        >
        </k-input>
      </span>
    </span>
    <div class="k-date-input-masked__error-text" v-if="errorText">{{ errorText }}</div>
  </span>
</template>

<script>
import { vMaska } from 'maska/vue';
import KInput from './input.vue';

export default {
  name: 'k-date-input-masked',
  components: {
    KInput,
  },
  directives: { maska: vMaska },
  props: {
    value: {
      type: String,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    required: {
      value: Boolean,
    },
    disabled: {
      value: Boolean,
    },
    errorText: {
      type: String,
    },
  },
  watch: {
    date: function value(newValue) {
      this.onChange(newValue);
    },
  },
  data() {
    return {
      date: this.value,
      placeholder: 'MM-DD-YYYY',
    };
  },
};

</script>

<style lang="scss" scoped>
.k-date-input-masked__input-field {
  margin-left: calc(var(--grid-unit) * 3);
}

.k-date-input-masked__icon {
  color: var(--gray-60);
}

.k-date-input-masked__error-text {
  color: var(--rust-50);
  margin-top: var(--grid-unit);
}

.k-date-input-masked__input-field :deep(.k-input) {
  border: 0;
  padding: 0;

  &:focus-within,
  &.k-input--focus {
    box-shadow: none;
  }
}
</style>
